import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import unsupportedOverflowMenuItem from 'notebook/structured-tables/action-functions/unsupportedOverflowMenuItem';
import CreateRequestFromSamplesButton from 'requests/creation/CreateRequestFromSamplesButton';
import {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

import {ActionFunctionParameters} from '../StructuredTableConstants';
import makeCustomButtonActionFunction from './makeCustomButtonActionFunction';

/**
 * An ActionFunction that creates a Request from samples in the finalize rows of the table.
 */

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const renderToolbarButton = <TTableMetadata, TRowMetadata>({
  structuredTable,
  structuredTableAdapter,
}: ActionFunctionParameters<TTableMetadata, TRowMetadata>) => (
  <CreateRequestFromSamplesButton
    buttonStyle={ButtonStyle.TERTIARY_GRAY}
    className="u-mini-spacing-left"
    sampleInfos={structuredTableAdapter.getSampleInfosForRequest(structuredTable)}
    size={ButtonSize.MINI}
  />
);

export const createRequestActionFunction = makeCustomButtonActionFunction({
  renderToolbarButton,
  renderOverflowMenuItem: unsupportedOverflowMenuItem,
  getHidden: () => !BenchlingConfig.ENABLE_REQUESTS,
});
